<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="toc_head">CONTENTS</p>
<p class="bigspace">
</p><p class="tocitem"><a href="#/html/06_acknowledgments">Acknowledgments</a></p>
<p class="xsmallspace">
</p><p class="tocitem"><a href="#/html/07_foreword">Foreword</a></p>
<p class="mediumspace">
</p><p class="tocitem"><a href="#/html/08_intro">Introduction: <span class="small1"><i>The Need for Foundations</i></span></a></p>
<p class="xsmallspace">
</p><p class="tocitem1">An Education in Freedom—The Specific Mission of a Catholic School—The Heart of the Book</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:1em"><span href="#/html/09_chap1" title="Link target outside of Sample">I.</span></span><span href="#/html/09_chap1" title="Link target outside of Sample">Child, Person, Teacher: <span class="small1"><i>At the Heart of a Catholic School</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">Revival of the Trivium—Centering Education on the Child—To Be a Child—Attention—A Catholic Philosophy of Education</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:.75em"><span href="#/html/10_chap2" title="Link target outside of Sample">II.</span></span><span href="#/html/10_chap2" title="Link target outside of Sample">Remembering: <span class="small1"><i>Grammar–Mythos–Imagining the Real</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">Naming: The First Human Task—Man the Mediator—Recollecting and the Spirit of Tradition—Anti-Tradition and <i>Anamnesis</i>—Defending the Art of Memory—The Hall of Fire—Music of Creation</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:.45em"><span href="#/html/11_chap3" title="Link target outside of Sample">III.</span></span><span href="#/html/11_chap3" title="Link target outside of Sample">Dialectic: <span class="small1"><i>Thinking–Logos–Knowing the Real</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">An Honorable Art—Encouraging Thought—Dialectics for Children—The Search for Truth—Faith and Reason—In Search of Foundations—Evolution—Dialectic</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:.45em"><span href="#/html/12_chap4" title="Link target outside of Sample">IV.</span></span><span href="#/html/12_chap4" title="Link target outside of Sample">Speaking: <span class="small1"><i>Rhetoric–Ethos–Community in the Real</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">Word of God, Breath of God—Ethos—Who Am I, Again?—Recovery of Freedom—Poetic Form—The Liturgical Heart</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:.8em"><span href="#/html/13_chap5" title="Link target outside of Sample">V.</span></span><span href="#/html/13_chap5" title="Link target outside of Sample">Wisdom: <span class="small1"><i>Beyond the Liberal Arts</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">The Other Arts—History—Dreaming a Catholic School</p>
<p class="mediumspace">
</p><p class="tocitem"><span class="small1" style="margin-right:.4em"><span href="#/html/14_chap6" title="Link target outside of Sample">VI.</span></span><span href="#/html/14_chap6" title="Link target outside of Sample">Learning in Love: <span class="small1"><i>Parents as Educators</i></span></span></p>
<p class="xsmallspace">
</p><p class="tocitem1">Cultivating the Moral Imagination—Education of the Heart—Charlotte Mason—John Holt—The Holy Family</p>
<p class="mediumspace">
</p><p class="tocitem"><span href="#/html/15_conclusion" title="Link target outside of Sample">Conclusion: <span class="small1"><i>Beauty in the Word</i></span></span></p>
<p class="mediumspace">
</p><p class="tocitem"><span href="#/html/16_coda" title="Link target outside of Sample">Coda</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/17_endnotes" title="Link target outside of Sample">Endnotes</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/18_bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/19_index" title="Link target outside of Sample">Index of Names</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?89ed5a52